const COLOR_WORDS = [
  "black",
  "white",
  "yellow",
  "red",
  "blue",
  "green",
  "grey",
  "gray",
  "silver",
  "orange",
  "purple",
  "brown",
  "beige",
  "gold",
];

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const colorForCar = (car) => {
  const definedColor = car.color || car.exterior_color;
  if (definedColor) return definedColor;

  const detectedColor = COLOR_WORDS.find((color) => (
    new RegExp(`\\b${color}\\b`, "i").test(car.name || "")
  ));

  return detectedColor
    ? `${detectedColor.charAt(0).toUpperCase()}${detectedColor.slice(1)}`
    : "—";
};

export const titleForCar = (car) => {
  const brandPattern = car.brand
    ? new RegExp(`^${escapeRegExp(car.brand)}\\s*`, "i")
    : null;
  const colorPattern = new RegExp(`\\b(${COLOR_WORDS.join("|")})\\b`, "gi");

  return (car.name || "")
    .replace(brandPattern, "")
    .replace(colorPattern, "")
    .replace(/\b(?:19|20)\d{2}\b/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
};

const cleanVehiclePart = (value) => String(value || "")
  .replace(/\bmodel\b/gi, "")
  .replace(/\b(?:19|20)\d{2}\b/g, "")
  .replace(/\s{2,}/g, " ")
  .trim();

export const displayVehicleName = (car) => {
  const brand = cleanVehiclePart(car.brand);
  const model = cleanVehiclePart(car.model);
  const trim = cleanVehiclePart(car.trim);
  const modelAndTrim = trim && !model.toLowerCase().includes(trim.toLowerCase())
    ? [model, trim].filter(Boolean).join(" ")
    : model;
  const displayName = [brand, modelAndTrim].filter(Boolean).join(" ").trim();

  return displayName || titleForCar(car);
};